<i18n lang="yaml">
  zh:
    title: "创作工具"
    subtitle: "探索更多创作辅助工具"
    latest_news: "最新动态"
    contribute_title1: "收稿合作"
    contribute_title: "火葬场真香杯"
    contribute_content1: "自主收稿平台，创建你的征稿函！"
    contribute_content: "短篇挑战赛进行中🔥"
    empty_desc: "还没有创作记录，快开启加速之旅吧！"
    empty_tip: "Start your journey!"
    all: "全部"
    signed: "已签约"
    delete_confirm: "确定删除吗?"
    confirm: "确定"
    cancel: "取消"
    delete_signed_tip: "已签约作品不能删除"
    delete_submitted_tip: "投稿作品不能删除，请先撤回投稿"
    delete: "删除"
    no_story_name: "该故事还没有名字"
    recent_edit: "最近编辑"
    completed: "完成状态"
    search_placeholder: "输入名称搜索"
    select_story_type: "请选择故事类型"
    select_perspective: "请选择写作视角"
    menu_command_missing: "菜单选项缺少command属性"
  en:
    title: "Authoring Tool"
    subtitle: "Explore more creative tools"
    latest_news: "Latest News"
    contribute_title: "Submission Cooperation"
    contribute_content: "Self-service submission platform, create your own call for papers!"
    empty_desc: "No creation records yet, start your journey now!"
    empty_tip: "Start your journey!"
    all: "All"
    signed: "Signed"
    delete_confirm: "Are you sure to delete?"
    confirm: "Confirm"
    cancel: "Cancel"
    delete_signed_tip: "Signed works cannot be deleted"
    delete_submitted_tip: "Submitted works cannot be deleted, please withdraw the submission first"
    delete: "Delete"
    no_story_name: "This story has no name yet"
    recent_edit: "Recently Edited"
    completed: "Completion Status"
    search_placeholder: "Enter name to search"
    select_story_type: "Please select story type"
    select_perspective: "Please select writing perspective"
    menu_command_missing: "Menu option missing command property"
</i18n>


<template>
<div>
    <div v-if="$i18n.locale === 'zh'" class="news-box" :class="{'news-box-pc': !isMobile, 'news-box-mobile': isMobile}">
      <div class="news-box-last" :class="{'news-box-last-pc': !isMobile, 'news-box-last-mobile': isMobile}" >
        <img src="../../assets/icon-zxdt-1.png" style="height: 36px;padding-top: 5px;padding-bottom: 5px;" />
        <span class="news-box-last-title" style="white-space: nowrap;">{{$t('latest_news')}}</span>
        <div class="news-box-last-content" style="display: inline-block;">
          <el-carousel style="height: 20px;line-height: 20px;width: 100%;text-wrap: nowrap;" direction="vertical" :autoplay="true" :loop="true" indicator-position="none">
            <el-carousel-item v-for="(item, index) in dongtai" :key="index">
              <a :title="item.title" style="text-wrap: nowrap;text-overflow: ellipsis;font-size: 12px;">{{ item.title }}</a>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="news-box-contribute pointer" style="" @click="gotoSubmissionLink">
        <img src="@/assets/icon-home-submission.png" style="width: 28px;padding-top: 5px;padding-bottom: 5px;">
        <span class="news-box-contribute-title">{{$t('contribute_title')}}</span>
        <span class="news-box-contribute-content">{{$t('contribute_content')}}</span>
      </div>

    </div>

    <HomeBox />
    <ToolBox />

    <StoryIdeaDialog v-if="showDialogCdpFlag && storyTiaojian.length>0" :enums="enums" channel="workspace_index" />
    <Gen4Outline v-if="storyTiaojian.length>0" :enums="enums" channel="workspace_index" />
  </div>
</template>
<script>
import * as StoryTemplateApi from '@/api/storytemplate'
import * as EnumApi from '@/api/enums'
import * as AccountApi from '@/api/account'
import * as ArticleApi from '@/api/article'
import * as EvaluationApi from '@/api/evaluation'
import * as CultureApi from '@/api/culture'
import * as StoryCpApi from '@/api/storycp'
import * as StorySynesthesiaElementApi from '@/api/storysynesthesiaelement'
import * as StoryHotApi from '@/api/storyhot'
import { mapState, mapMutations} from 'vuex'
import StoryIdeaDialog from '@/components/StoryIdeaDialog/index'
import Gen4Outline from '@/components/Gen4Outline'
import HomeBox from '@/components/homebox/box-create'
import ToolBox from '@/components/homebox/box-tool'
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
export default {
  name: 'Article',
  components: {
    StoryIdeaDialog,Gen4Outline,HomeBox,ToolBox
  },
  data() {
    return {
      genTypeActive: 'ALL',
      fromType: 'writer_client',
      dialogShowGenbyoutline: false,
      showStateFlag: true,
      dialogShowGenbyidea: false,
      // enums: {"ArticleTypeEnum":[{"desc":"","name":""}]},
    	targetPermit: 'article',
      queryForm: {
        name: '',
        fromType: 'writer-web',
        articleGenType: '-1',
        articleGenTypes: [],
        articleState: '',
        current: '',
        size: 20
      },
      activeMenuItem: 1,
      synesthesiaElements:[],
      cps:[],
      hots:[],
      storyTemplates:[],
      dongtai: [],
      tougao: [],
      data: [],
      data1: [
        {
          icon: '@/assets/renwusheding.png',
          type: 'PLAY',
          title: '人物设定',
          desc: '完整人物设定档案，帮助剧本创作'
        },
        {
          icon: '@/assets/duanpiandaoyu.png',
          type: 'STORY',
          title: '短篇导语',
          desc: '一键生成爆款短篇导语'
        },
        {
          icon: '@/assets/redianxuanti.png',
          type: '',
          title: '热点选题',
          desc: '不知道写什么？最热选题'
        },
      ],
      queryForm: {
        name: '',
        fromType: 'writer-web',
        articleGenType: '-1',
        articleGenTypes: [],
        articleState: '',
        current: '',
        size: 20
      },
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  mounted() {
    this.setShowZhilingPanelFlag(false)
    this.setActiveMenuItem('1')
    this.handleEnum()
    this.handlePage()
    this.handleTemplatePage()
    this.setStoryContents([])
    this.handleMessage()
    this.showTips()
  },
  computed: {
  	...mapState(['user', 'story', 'showDialogCdpFlag','enums','token',
    'showDialogDpFlag', 'showGenbyoutlineFlag', 'storyTiaojian']),
    isMobile() {
      return window.innerWidth <= 768 ? true : false;
    }
  },
  methods: {
    ...mapMutations(['setActiveMenuItem','setStory','setStoryContents','setEnums','setUser',
    'setShowGenbyoutlineFlag', 'setShowDialogCdpFlag', 'setShowDialogDpFlag',
     'setShowChangpianDialogFlag', 'setActiveTemplate', 'setStoryTiaojian', 'setShowZhilingPanelFlag']),
    showTips() {
      console.log('引导开始..')
      if(this.token == ''){
        return false
      }
      if(this.user.tourFlag){
        return false
      }
      const driverObj = driver({
        onDestroyed: () => {
          console.log('引导已结束')
          AccountApi.update({id: this.user.id, tourFlag: true}).then(res => {
            this.user.tourFlag=true
            this.setUser(this.user)
          })
        },
        nextBtnText: '下一步—›',
        prevBtnText: '‹—',
        doneBtnText: '关闭',
        showButtons: [
                'next',
                'previous',
                'close'
              ],
        showProgress: false,
        allowClose: false,
        steps: [
          {
            element: '#myworks',
            popover: {
              title: '👈您创作的历史作品，在这里哦～',
              description: '',
              side: "right",
              align: 'center'
            }
          },
          {
            element: '#myworks1',
            popover: {
              title: '👈也可以从这里进入～',
              description: '',
              side: "right",
              align: 'center'
            }
          }
        ]
      });
      driverObj.drive();
    },
    gotoSubmissionLink(){
      // window.open('https://maliwriter.com/newsdetail/1946474338811432962', '_blank')
      window.open('https://maliwriter.com/newsdetail/1955463272530735106', '_blank')
    },
    contentChange(item){
      console.log('contentChange', item);
    },
    getTailByGenType(item){
      let tail = ''
      if(item.articleGenType == 'GEN_BY_ZHIHU' || item.articleGenType == 'GEN_BY_OUTLINE'){
        tail = this.$i18n.locale === 'zh' ? '短篇小说' : 'Short Story'
      }else if(item.articleGenType == 'GEN_BY_IDEA'){
        tail = this.$i18n.locale === 'zh' ? '超短篇小说' : 'Mini Story'
      }else if(item.articleGenType == 'GEN_BY_CHANGPIAN'){
        tail = this.$i18n.locale === 'zh' ? '长篇小说' : 'Novel'
      }else{
        tail = ''
      }
      return tail;
    },
    handleTemplateClick(item) {
      // console.log(item);
      this.setActiveTemplate(item)
      let story = {id: ''}
      story.articleGenType = 'GEN_BY_ZHIHU'
      story.articleType = 'FEEL_GOOD'
      this.setStory(story)
      setTimeout(()=>{
        this.$router.push('/workspace/gen')
      }, 300)
    },
    handleTemplatePage(){
      StoryTemplateApi.page({
        templateType: 'GUANFANG',
        enableFlag: true,
        size: 6
      }).then(res => {
        let result = res.data.data;
        this.storyTemplates = result.records;
      });
    },
    handleGen(cmditem) {
      if (!cmditem) {
        this.$message.error(this.$t('menu_command_missing'))
        return
      }
      let story = {id: ''}
      switch (cmditem) {
        case 'genbyidea'://cdp
          // gen story
          story.articleGenType = 'GEN_BY_IDEA'
          story.articleType = 'TANBI_DOUBLE_BOY'
          this.setStory(story)
          this.setShowDialogCdpFlag(true)
          break
        case 'genbyoutline'://duanpian dingzhi
          // gen story
          story.articleGenType = 'GEN_BY_OUTLINE'
          story.articleType = 'FEEL_GOOD'
          story.articleStyle = 'ZHENGWEN'
          story.writingPerspective = 'FIRST_PERSON'
          this.setStory(story)
          this.setShowGenbyoutlineFlag(true)
          break
        case 'genbyzhihu'://dp
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen'})
          break
        case 'genbychangpian'://changpian
          story.articleGenType = 'GEN_BY_CHANGPIAN'
          story.articleType = 'CP_YANQING'
          this.setStory(story)
          this.setShowChangpianDialogFlag(true)
          this.$router.push({ path: '/workspace/gencp'})
          break
        case 'chaishu':// chaishu
          this.$router.push({ path: '/bookbreakdown/index'})
          break
      }
    },
    newStoryByOutline() {
      if (!this.story.articleType || !this.story.articleType.trim()) {
          this.$message.error(this.$t('select_story_type'));
          return false;
      }

      if (!this.story.writingPerspective || !this.story.writingPerspective.trim()) {
          this.$message.error(this.$t('select_perspective'));
          return false;
      }
      // return false;
      ArticleApi.create(this.story).then(res => {
          if(res.data.code == 0){
            let data = res.data.data
            this.setStory(data)
            console.log('story', this.story);
            this.$router.push('/workspace/genbyoutline');
          }else{
            this.$message.error(res.data.msg);
          }
      })
    },
    handleRemove(item) {
      this.$confirm(this.$t('delete_confirm'),this.$t('confirm'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        customClass: 'custom-confirm',
        center: false
      }).then(() => {
        ArticleApi.remove(item.id).then(res => {

        });
      }).catch((e) => {console.log('error', e)});
    },
    itemClick(item){
      this.setStory(item)
      setTimeout(()=>{
        if(!item.stepNumber || item.stepNumber == 0 || item.stepNumber == 1){
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
              this.$router.push('/workspace/gen')
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea')
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline')
          }
        }else {
          if(this.story.articleGenType == 'GEN_BY_ZHIHU'){
            this.$router.push('/workspace/gen' + (item.stepNumber-1))
          }else if(this.story.articleGenType == 'GEN_BY_CHANGPIAN'){
            this.$router.push('/workspace/gencp')
          }else if(this.story.articleGenType == 'GEN_BY_IDEA'){
            this.$router.push('/workspace/genbyidea' + item.stepNumber)
          }else if(this.story.articleGenType == 'GEN_BY_OUTLINE'){
            this.$router.push('/workspace/genbyoutline' + item.stepNumber)
          }
        }
      }, 300)
    },
    handleEnum() {
      EnumApi.map().then(res => {
        let result = res.data.data;
        console.log('result', result);
        let tree = this.$buildTree(result, 0, 0)
        console.log('tree', tree);
        this.setStoryTiaojian(tree)
      })
      let that = this;
      EnumApi.list().then(res => {
        let result = res.data.data;
        result.ArticleStateEnum.unshift({name: '-1', desc: this.$t('all')})
        result.ArticleStateEnum.push({name: 'SIGN_OK', desc: this.$t('signed')})
        result.ArticleGenTypeEnum.shift()
        result.ArticleGenTypeEnum.unshift({name: '-1', desc: this.$t('all')})
        that.setEnums(result)
      })
    },
    sortByCode(array, order = 'asc') {
      return [...array].sort((a, b) => {
        if (typeof a.code === 'number' && typeof b.code === 'number') {
          return order === 'asc' ? a.code - b.code : b.code - a.code;
        } else {
          return order === 'asc'
            ? a.code.toString().localeCompare(b.code.toString())
            : b.code.toString().localeCompare(a.code.toString());
        }
      });
    },
    handlePage(item) {
      if(item && item.name != 'ALL'){
        this.genTypeActive = item.name
        this.data = this.data1.filter(i => item.name==i.type)
      }else{
        this.genTypeActive = 'ALL'
        this.data = this.data1
      }
    },
    handleMessage() {
      CultureApi.page({size: 100}).then(res => {
        let result = res.data.data;
        this.dongtai = result.records
      })
      EvaluationApi.page({size: 100}).then(res => {
        let result = res.data.data;
        this.tougao = result.records
      })
    }
  }
}
</script>

<style scoped lang="scss">
.layout {
  height: 100%;
}
.main {
  min-height: 1px;
  flex: 1;
}
.el-aside {
  padding: 0px;
  margin-bottom: 0 !important;
  height: 100%;
  width: 17rem !important;
}
.el-scrollbar {
  height: 100%;
  background-color: #ffffff;
}
.el-header {
  padding: 0px !important;
  background-color: #001A40;
}
.el-main {
  height: 100%;
  overflow: hidden; /* 禁止父容器滚动 */
}
.dialog-container {
  background: #F4F5F9;
  border-radius: 20px;
  height: calc( 100% - 1rem );
  margin: 0 1rem 1rem;
  margin-bottom: 1rem;
  padding:1rem;
  overflow: auto;
}
.el-drawer.rtl {
    right: 0;
    overflow-y: auto !important;
}
/deep/ .el-card {
    // border: 0;
    overflow-y: hidden !important;
}
/deep/ .el-empty__image img {
  margin-top: 20px;
}
.custom-select {
    /deep/ .el-input__inner {
      border-radius: 20px;
      height: 1.5rem;
      line-height: 1.5rem;
    }
    /deep/ .el-input__suffix {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
}

/deep/ .el-carousel__item {
  white-space: nowrap;
  overflow: hidden;        /* 隐藏超出元素盒子的内容 */
  text-overflow: ellipsis; /* 显示省略号(...) */
}
.search-title {
  /deep/ .el-input__inner {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
  }
  /deep/ .el-input__suffix {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
.el-input__inner .el-input__inner:hover {
    /deep/ {
      // border-color: transparent; /* 边框颜色设置为透明 */
      // border: none;
      // outline: none;
    }
}

.writer-home-card-box{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}
.writer-home-card {
  flex: 1;
  cursor: pointer;
  // border: 1px solid red;
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
  border-radius: 14px;
  box-sizing: border-box; /* 边框计算在宽度内 */
  &-title-en {
    font-weight: 400;
    font-size: 14px;
    color: rgba(255,255,255,.8);
    line-height: 22px;
    border-radius: 20px;
    display: inline-block;
    padding: .1rem 1rem;
  }
  &-title {
    font-weight: 600;
    font-size: 28px;
    color: rgba(0,0,0,0.9);
    margin: 1rem 0;
  }
  &-top {
    display: flex;
    justify-content: space-between;
    &-img {
      width: 7rem;
      margin-top:  -.7rem;
    }
  }
  &-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    &-img {
      width: 1rem;
    }
  }
  &-up {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.4);
    line-height: 22px;
    display: flex;
    align-items: flex-start; /* 顶部对齐 */
    &-icon {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #2BA471;
      line-height: 1rem;
      margin-right: .5rem;
      border-radius: 3px;
      padding: .25rem .5rem;
      &-img {
        width: 1rem;
      }
    }
  }
}
.writer-home-card-box > :nth-child(1) {
  background-image: url('../../assets/writer-edit2.png'), linear-gradient( 151deg, rgba(125,174,255,0.6) 0%, rgba(148,255,197,0.3) 50%, rgba(172,195,255,0.1) 100%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right top;
  // background-image: ;
}
.writer-home-card-box > :nth-child(2) {
  background-image: url('../../assets/writer-light2.png'), linear-gradient( 137deg, rgba(137,150,255,0.6) 0%, rgba(235,210,255,0.6) 45%, rgba(144,126,255,0.04) 100%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right top;
}
.writer-home-card-box > :nth-child(3) {
  background-image: url('../../assets/writer-changpian.png'), linear-gradient( 314deg, #FFECA8 0%, #FFFEDE 50%, #FFD4AC 100%);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right top;
}
.word-count-tail {
  border-radius: 6px 0px 20px 0px;
  width: auto; /* 默认值，但明确设置有助于理解 */
  white-space: nowrap; /* 防止文本换行 */
  display: inline-block;
  padding: .25rem 1.5rem .25rem 1rem;
  // font-weight: 600;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  &-cdp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F2F3FE 100%);
    color: #0052D9;
  }
  &-dp{
    background: linear-gradient( 90deg, #DAE1FF 0%, #F6F2FE 100%);
    color: #4043FF;
  }
  &-cp{
    background: linear-gradient( 90deg, #FFE9BC 0%, #FFF7DC 100%);
    color: #FD733B;
  }
}
.data-empty {
  background: #FFFFFF;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.1);
  border-radius: 0px 20px 20px 20px;
  padding: 1rem;
}
/deep/ .el-empty {
  min-height: 30vh !important;
}
/deep/ .el-empty__bottom {
  margin-top: 10px;
}
.authoring-tool {
  background: #FFFFFF;
  border-radius: 30px 30px 30px 30px;
  padding: 2rem 1rem;
}

.authoring-tool-box {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  &-item {
    background: #F6F7FF;
    box-shadow: 0px 5px 20px -8px rgba(9,32,153,0.2);
    border-radius: 20px 20px 20px 20px;
    padding: 1rem;
    min-width: 200px;
    cursor: pointer;
    &-title {
      font-weight: 600;
      font-size: 16px;
      color: #242424;
      padding: 1rem 0;
    }
    &-subtitle {
      font-weight: 400;
      font-size: 12px;
      color: rgba(36,36,36,0.5);
    }
  }
  &-item:hover {
    box-shadow: 4px 4px 15px 0 rgba(54, 110, 244, .2) !important;
  }
}

/* 假设你的菜单类名为 .my-menu */
/deep/ .el-menu-agent .el-menu-item {
  border-radius: 6px !important;
  margin: 0 1rem 6px;
  height: 2.5rem;
  line-height: 2.5rem;
}
/deep/ .el-menu-agent .el-menu-item:hover {
  background-color: #4B4B4B !important;
}
.el-menu-agent .el-menu-item.is-active {
  background-color: #0252D9 !important; /* 激活状态下的背景颜色 */
}


@media screen and (min-width: 500px) {
  .writer-home-card-box {
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  }
  /deep/ .custom-dialog .el-dialog {
    width: 60%;
  }
}
.news-box {
  display: flex;
  margin-bottom: 1rem;
  &-pc{
    justify-content: space-between;
  }
  &-mobile{
    flex-direction: column;
  }
  &-last {
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
    display: flex;
    align-items: center;
    padding: 0 1rem 0 .25rem;
    &-pc{
      flex: 1;
      margin-right: 1rem;
    }
    &-mobile{
      margin-bottom: 1rem;
    }
    &-title {
      color: #366EF4;
      font-weight: 600;
      line-height: 24px;
      font-size: 16px;
      margin-left: 10px;
    }
    &-content {
      margin-left: 1rem;
      color: #242424;
      flex: 1;
      font-size: 14px;
    }
  }
  &-contribute {
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
    display: flex;
    align-items: center;
    padding: 0 1rem 0 .25rem;
    width: 380px;
    &-title {
      color: #366EF4;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      text-wrap: nowrap;
      margin-left: 10px;
    }
    &-content {
      margin-left: 1rem;
      color: #366EF4;
      font-size: 14px;
    }
  }
}

/* 小屏下的样式 */
@media (max-width: 767px) {
  .news-box-contribute {
    width: 100% !important;
  }
}
// mly end
</style>

<style>
.custom-carousel {
  position: relative;
  width: 100%;
}

.custom-carousel .el-carousel__indicators--vertical {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-carousel .el-carousel__indicator--vertical {
  margin: 5px 0;
}

.custom-carousel .el-carousel__indicator button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, .6);
  border: 1px solid rgba(255, 255, 255, .6);
  opacity: 0.5;
}

.custom-carousel .el-carousel__indicator--vertical.is-active button {
  background-color: #647EFF;
  border-color: #647EFF;
  opacity: 1;
}
</style>
